"use strict"

// Form
import { FieldButton } from '@/lib/core/components/data/form/FieldButton'

export class irParaMapaButton extends FieldButton {
  #form
  constructor({ form, register, fields, name = 'irParaMapaButton', Logic }) {
    super({ form, register, fields, name, Logic, originClass: irParaMapaButton })
    this.#form = form
  }
  async clickIrParaMapa() {
    window.showOverlay()
    window.routerPush({ name: 'maps', query: { hmenuOpened: 'Mapas' } })
      .then(()=>{ window.hideOverlay() })
      .catch((error)=>{ console.log(error); window.hideOverlay() })
  }
}